// appSlices.js
import { createSlice } from "@reduxjs/toolkit";
import config from "../config/config";

const MAX_MESSAGES = config.MAX_MESSAGES; // Set this to the maximum number of messages to retain

const siteNameSlice = createSlice({
    name: "siteName",
    initialState: {
        siteName: "Glassyfied", // Dummy data to be persisted
    },
    reducers: {
        setSiteName: (state, action) => {
            state.siteName = action.payload;
        },
    },
});


const authSlice = createSlice({
    name: "auth",
    initialState: {
        accessToken: '',  // Change to empty string
        refreshToken: '', // Change to empty string
        // user: {},        // Change to empty object
    },
    reducers: {
        setCredentials: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            // state.user = action.payload.user;
        },
        clearCredentials: (state) => {
            state.accessToken = "";
            state.refreshToken = "";
            // state.user = {};
        },
    },
});

// Chat slice
const chatSlice = createSlice({
    name: "chat",
    initialState: {
        history: [],
    },
    reducers: {
        addMessage: (state, action) => {
            state.history.push(action.payload);
            if (state.history.length > MAX_MESSAGES) {
                state.history = state.history.slice(-MAX_MESSAGES);
            }
        },
        setHistory: (state, action) => {
            state.history = action.payload.slice(-MAX_MESSAGES);
        },
        clearHistory: (state) => {
            state.history = [];
        },
        updateLikeDislike: (state, action) => {
            const { content_id, like_dislike } = action.payload;
            const message = state.history.find(item => item.content_id === content_id);
            if (message) {
                message.like_dislike = like_dislike; // update the like/dislike status
            }
        },
        updateComment: (state, action) => {
            const { content_id, comment } = action.payload;
            const message = state.history.find(item => item.content_id === content_id);
            if (message) {
                message.comment = comment; // update the comment
            }
        },
    },
});

// Bookmarks slice
const bookmarksSlice = createSlice({
    name: "bookmarks",
    initialState: {
        bookmarks: [],
    },
    reducers: {
        setBookmarks: (state, action) => {
            state.bookmarks = action.payload;
        },
        clearBookmarks: (state) => {
            state.bookmarks = [];
        },
        addBookmark: (state, action) => {
            if (state.bookmarks === undefined || state.bookmarks === null) {
                state.bookmarks = [];
            }
            state.bookmarks.unshift(action.payload);
        },
        removeBookmark: (state, action) => {
            // Filter out the bookmark with the specified contentID
            state.bookmarks = state.bookmarks.filter(
                (bookmark) => bookmark.content_id !== action.payload
            );
        },
    },
});

// Notifications slice
const notificationsSlice = createSlice({
    name: "notifications",
    initialState: {
        notifications: [],
    },
    reducers: {
        setNotifications: (state, action) => {
            state.notifications = action.payload;
        },
        addNotification: (state, action) => {
            state.notifications.push(action.payload);
        },
        clearNotifications: (state) => {
            state.notifications = [];
        },
    },
});

// Export actions for both slices
export const { setSiteName } = siteNameSlice.actions;

export const {
    setCredentials,
    clearCredentials
} = authSlice.actions;

export const {
    addMessage,
    setHistory,
    clearHistory,
    updateLikeDislike,
    updateComment,
} = chatSlice.actions;

export const {
    setBookmarks,
    clearBookmarks,
    addBookmark,
    removeBookmark,
} = bookmarksSlice.actions;

export const {
    setNotifications,
    addNotification,
    clearNotifications,
} = notificationsSlice.actions;


// Combine reducers
const appReducers = {
    siteName: siteNameSlice.reducer,
    auth: authSlice.reducer,
    chat: chatSlice.reducer,
    bookmarks: bookmarksSlice.reducer,
    notifications: notificationsSlice.reducer,
};


export default appReducers;
